export const SET_CONTACTS_FILTERS = 'SET_CONTACTS_FILTERS';

export const setContactsFilters = ({ searchText }) => ({
    type: SET_CONTACTS_FILTERS,
    payload: {
        searchText
    }
});
